import { useEffect, useRef, useState } from "react"
import { proxy, useSnapshot } from "valtio"
import { configStore, contractsStore, entityStore, loginStore, modalStore, bookingsStore, EntityV2Store, filtersState, filtersOptions, aguserStore, AgmodalStore } from "../state/CommonState"
import { Cargo, Container, enquiryStore } from "../enquiry/enquiry-data"
import EnquiriesApi from "../state/enq-api"
import Agproducttab from "../components/Agproducttab"
import Utils from "../util/Utils"
import { rtpStore } from "../pricing/pricing-store"
import PricingUtils from "../pricing/pricing.utils"
import MonApi from "../state/mongo-api"
import AgCustlist, { AgSelectNew } from "../components/AgCustlist"
import BookingConfirmation from "../schedules/booking-confirmation"
import SpotLCLDisplayv3 from "./spot.lcl.display-v3"
import Pricingcwf from "../pricing/pricing.cwf"
import { Button, Menu } from "@mui/material"
import EnquiryConfirmationv3 from "../enquiryv3/enquiry-confirmation-v3"
import ActrejectModalV3 from "../enquiryv3/enquirysuggestion-v3"
import SpotFCLDisplayv3 from "./spot.fcl.display-v3"
import SpotAirDisplayv3 from "./spot.air.display-v3"
import { ActiveTab } from "../v3-componets/AgActiveTab"
import { useForm } from "react-hook-form"
import { SHIPMENT_SCOPE } from "../util/quotationUtil"
import { Route } from "../v3-componets/AgRoute"
import { Details } from "../v3-componets/AgDetails"
import { loader } from "../util/loader"
import filtericon from "../assets/images/filterfilled.svg"
import { QuickQuoteFilters } from "../mui-components/QuickQuoteFilters"
import { Nodata } from "../mui-components/nodatafound"
import { cartingStore } from "../cartingorder/cartingStore"
import AguserApi from "../state/AguserApi"
import ManualRates from "../pricing/manualRates"
import Api from "../state/Api"
import { getTC } from "../TC"
import EntityV2Api from "../state/entities-api"
import EntityApi from "../state/entity-api"
import EditSchedule from "./editschedule"
import { editStore } from "./editStore"
import EditCharge from "./editcharge"
import CopyMail from "./copymail"
import { useMobile } from "../hooks/usemobile"
import { MRGCARGODETAILS } from "../util/constants"
import TenantUtils from "../util/tenant.utils"
import EditChargenew from "./editchargenew"
import on from '../components/on2.png';
import off from '../components/off.png';
import isEqual from 'lodash/isEqual.js';

let pricingStore = proxy({
    gst: '',
    origin: '',
    destination: ''
})
function EnquiryOption(props) {
    useSnapshot(enquiryStore)
    useSnapshot(loginStore)
    useSnapshot(rtpStore)
    const isMobile = useMobile()
    let setRoutes = props.setRoutes
    let setmRates = props.setmRates
    let payloaddata = props.payloaddata
    let message = `We do not have these routes real-time but, would love to provide a customized solution.
    We will get in touch with your shortly over Phone or E-mail.`
    let oklabel = 'OK'
    let cancellabel = 'No'
    if (!loginStore.isClient()) {
        message = 'Real-time rates unavailable'
        oklabel = 'Submit Enquiry'
        cancellabel = 'Cancel'
    }

    const content = (
        <div style={{
            width: isMobile ? '100%' : '50%',
            margin: 'auto',
            padding: isMobile ? '1.5rem 1.25rem' : '3rem',
            border: isMobile ? 'none' : '1px solid black',
            backgroundColor: '#D4F2B5',
            borderRadius: isMobile ? '12px' : '0px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                fontSize: isMobile ? '1rem' : '1.1rem',
                fontWeight: '500',
                color: '#1e293b',
                marginBottom: isMobile ? '1.25rem' : '1rem',
                textAlign: isMobile ? 'center' : 'left'
            }}>{message}</div>

            <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column-reverse' : 'row',
                justifyContent: 'flex-end',
                gap: '10px',
                width: '100%'
            }}>
                <button className="button is-danger" style={{ float: isMobile ? 'none' : 'right', width: isMobile ? '100%' : 'auto' }}
                    onClick={(e) => {
                        props.setMessage('')
                    }}
                >{cancellabel}</button>

                {
                    (cartingStore.current._id != undefined && cartingStore.current._id.length > 0) ? <button className="button islink " style={{ marginRight: isMobile ? '0' : '1%', width: isMobile ? '100%' : 'auto' }} onClick={() => {
                        cartingStore.current.internalremarks = ""
                        cartingStore.current.supportingDocuments_list = []
                        const callback = (data) => {
                            let dummyContract = {
                                origin: enquiryStore.current.enqRoute.origin,
                                portOfReceipt: cartingStore.current.portOfReceipt,
                                portOfLoading: cartingStore.current.portOfLoading,
                                portOfDischarge: cartingStore.current.portOfDischarge,
                                finalPlaceOfDelivery: cartingStore.current.finalPlaceOfDelivery,
                                destination: enquiryStore.current.enqRoute.destination,
                                shipmentType: enquiryStore.current.shipmentType,
                                shipmentScope: enquiryStore.current.shipmentScope,
                                isCarting: "Yes",
                                reworkingPort: cartingStore.current.reworkingPort
                            }
                            Object.assign(data, dummyContract)
                            if (enquiryStore.current.shipmentType == 'Air') {
                                data.tc = getTC(enquiryStore.current.shipmentType)
                            }
                            setRoutes([{ sources: [], dummyContract: data }])
                            data.schedules = []
                            data.chargesList = []
                            contractsStore.current = JSON.parse(JSON.stringify(data))
                            cartingStore.setSchedule()
                            if (cartingStore.current.salesperson !== enquiryStore.current.salesperson) cartingStore.current.salesperson = data.salesperson
                            if (cartingStore.current.customerService !== enquiryStore.current.customerService) cartingStore.current.customerService = data.customerService

                            setmRates(true)
                        }
                        Api.getdummycontranct(payloaddata, callback)
                    }}>Enter Rates Manually</button> : <>{
                        (rtpStore.customerTBA != 'TBA' && (!rtpStore.records || !rtpStore.records?.length)) &&
                        <button className="button islink" style={{ float: isMobile ? 'none' : 'right', width: isMobile ? '100%' : 'auto' }}
                            onClick={(e) => {
                                props.setMessage('')
                                if (!loginStore.isClient()) {
                                    configStore.quotationModalVisible4 = true
                                } else {
                                    EnquiriesApi.saveEnquiry()

                                }
                            }}
                        >{oklabel}</button>
                    }</>
                }
            </div>
        </div>
    )

    if (isMobile) {
        return (
            <div className="modal is-active" style={{ zIndex: 1000 }}>
                <div className="modal-background" onClick={() => props.setMessage('')} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}></div>
                <div className="modal-card" style={{ width: '90%', maxWidth: '400px', margin: 'auto' }}>
                    <section className="modal-card-body" style={{ padding: '0', borderRadius: '12px', overflow: 'hidden' }}>
                        {content}
                    </section>
                </div>
            </div>
        )
    }

    return content
}
function RoutesEmpty({ message, setMessage, setRoutes, setmRates, payloaddata }) {
    useSnapshot(rtpStore)
    let marr = ['Enumerating Routes...', 'Calculating Cost...',
        'Loading Schedules...', 'Fetching Transport Rates...', 'Optimizing Results...',
        'Sorting Results...', 'Serializing ...']
    if (message == 'No Routes') return <EnquiryOption setMessage={setMessage} setRoutes={setRoutes} setmRates={setmRates} payloaddata={payloaddata} />

    message = '' + message
    if (message.startsWith('Fetching')) {
        let m = marr[rtpStore.loadingCounter % 5]
        if (!m || typeof m == 'undefined') m = 'Enumerating Routes...'
        return <div className="title is-3" style={{ color: 'blueviolet', marginBottom: "100px" }}>{'' + m}</div>
    }
    return (
        <div className="title is-5">{'' + message}</div>
    )

}

function FiltersMenu({ showSortBy }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => {
        setAnchorEl(null);
    };
    return <>
        <div onClick={handleClick} className="cursor-pointer bg-white rounded-[9px] flex flex-row gap-2 h-[46px] px-4 justify-center items-center border-1 border-solid border-[#DADADA]">
            <img style={{ height: "15px", width: "15px" }} src={filtericon} />
            <p className="text-black">Filters</p>
        </div>
        <Menu anchorEl={anchorEl}
            open={isOpen}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
            <div className="max-h-[320px] overflow-y-auto">
                <QuickQuoteFilters showSortBy={showSortBy} />
            </div>
        </Menu>
    </>
}

export default function SpotBookingv3(props) {
    let viewonly = '0'
    useSnapshot(configStore)
    useSnapshot(loginStore)
    useSnapshot(pricingStore)
    useSnapshot(enquiryStore)
    useSnapshot(rtpStore)
    useSnapshot(bookingsStore)
    useSnapshot(modalStore)
    useSnapshot(EntityV2Store)
    useSnapshot(filtersState);
    useSnapshot(aguserStore)
    useSnapshot(cartingStore)
    useSnapshot(editStore)
    const [routeFilter, setRouterFilter] = useState('Cheapest')
    let cheapestColor = routeFilter == 'Cheapest' ? 'islink' : ''
    let fastestColor = routeFilter == 'Fastest' ? 'islink' : ''
    const [cwfVisible, setcwfVisible] = useState(false)
    const [mrates, setmRates] = useState(false)
    const [freeze, setFreeze] = useState(false)
    const [showonly, setShowonly] = useState(false)
    const [selectedType, setType] = useState(enquiryStore.current.shipmentType);
    const [agActiveList, setAgActiveList] = useState([])
    const [payloaddata, setPayloaddata] = useState({})
    const [openScheduleModel, setOpenScheduleModel] = useState(false)
    const [openChargeModel, setOpenChargeModel] = useState(false)
    const [openCopyMail, setOpenCopyMail] = useState(false)
    const [mrg, setMrg] = useState(false)
    const [rateRequestpayload, setRateRequestpayload] = useState({})
    let dv = {
        mode: "LCL",
        origin: (TenantUtils.isNavexel() && enquiryStore.current.enqRoute.origin.length==0)?"Nhava Sheva, India (INNSA)":enquiryStore.current.enqRoute.origin,
        orginScope: false,
        destinationScope: false,
        cargoreadinessdate: Utils.yyyymmdd(new Date()),
        scope: SHIPMENT_SCOPE.P2P,
        shipmentType: enquiryStore.current.shipmentType,
        originType: false,
        destinationType: false,
        customerreference: enquiryStore.current.enqRoute.customerReferenceNum,
        hazardous: enquiryStore.current.hazardous === "No" ? false : true,
        quoteClass: enquiryStore.current.quoteClass,
        packingGroup: enquiryStore.current.packingGroup,
        temperature: enquiryStore.current.temperature,
        cargoValue: enquiryStore.current.cargoValue,
        unnumber: enquiryStore.current.unnumber,
        nonStackable: enquiryStore.current.nonStackable === "No" ? false : true,
        temperatureControlled: enquiryStore.current.temperatureControlled === "No" ? false : true,
        minTemperature: enquiryStore.current.minTemperature,
        maxTemperature: enquiryStore.current.maxTemperature,
        stuffingType: enquiryStore.current.stuffingType,
        destuffingType: enquiryStore.current.destuffingType,
        status: "ENQUIRY",
        cargoDimensionUnit: "Cms",
        enqRoute: enquiryStore.current.enqRoute,
        vehicledetails: enquiryStore.current.vehicles,
        isFba: false,
        showPalletLabel: false,
        ior: false,
        iorParty: enquiryStore.current.iorParty,
        occ: false,
        dcc: false,
        survey: false,
        storageAtDestination: false,
        days: 0,
        palletizationandlabelling: true,
        showCargoDetailsOutGuage: false,
        pick_up_by_amazon: false,
        multidest: enquiryStore.current.multidest,
        containerDetails: [new Container()],
        fbaalways: "No"
    }
    if (AgmodalStore.modalPage == 'cartingbooking') {
        let dv1 = {
            overHeight: enquiryStore.current.overHeight === "No" ? false : true,
            overlength: enquiryStore.current.overlength === "No" ? false : true,
            topLoading: enquiryStore.current.topLoading === "No" ? false : true,
            fumigation: enquiryStore.current.fumigation === "No" ? false : true,
            headLoad: enquiryStore.current.headLoad === "No" ? false : true,
            doorLoad: enquiryStore.current.doorLoad === "No" ? false : true,
            reefer: enquiryStore.current.reefer === "No" ? false : true,
            overHeightValue: enquiryStore.current.overHeightValue,
            overlengthValue: enquiryStore.current.overlengthValue
        }
        dv = { ...dv, ...dv1 }
    }
    const cargoForm = useForm({
        defaultValues: dv
    })
    useEffect(() => {
        if (enquiryStore.current.shipmentType.length > 3 && enquiryStore.current.shipmentType.toLowerCase().indexOf('fcl') != -1) {
            enquiryStore.current.shipmentType = 'FCL'
            setValue("mode", 'FCL');
        }
        if (enquiryStore.current.multidest == undefined) {
            if (enquiryStore.current.containerDetails == undefined) enquiryStore.current.containerDetails = [new Container()]
            if (enquiryStore.current.cargoDetails == undefined) enquiryStore.current.cargoDetails = [new Cargo()]
            setValue("multidest", [
                {
                    destination: enquiryStore.current.enqRoute.destination,
                    cargoDetails: enquiryStore.current.cargoDetails,
                }
            ]);
            enquiryStore.current.multidest = [
                {
                    destination: enquiryStore.current.enqRoute.destination,
                    cargoDetails: enquiryStore.current.cargoDetails,
                }
            ]
        }
    }, [enquiryStore.current])
    useEffect(() => {
        setValue("mode", selectedType);
    }, [selectedType])
    const { control, watch, register, setValue, getValues, handleSubmit, reset, clearErrors, formState, trigger, getFieldState } = cargoForm;
    const changeShipmentTypes = (type) => {
        setActiveProduct(type)
        setType(type)
        setValue("isFba", false);
        setmRates(false)
        setcwfVisible(false)
        const entityId = enquiryStore.current.entityId
        if (cartingStore.current._id == undefined || cartingStore.current._id.length == 0) {
            enquiryStore.initialize();
            enquiryStore.current.entityId = entityId
        }
        enquiryStore.current.shipmentType = type
        cartingStore.current.mode = type
        if (cartingStore.current._id == undefined || cartingStore.current._id.length == 0) {
            if (type == 'FCL') {
                setValue("searchDB", true);
                setValue("searchFreightfy", true);
                setValue("searchCMACGM", true);
            }
            if(TenantUtils.isNavexel() && (Scope==SHIPMENT_SCOPE.P2P || Scope==SHIPMENT_SCOPE.P2D)){
                setValue("origin", "Nhava Sheva, India (INNSA)");
            }else{
                setValue("origin", "");
            }
            setValue("multidest", [
                {
                    destination: "",
                    cargoDetails: [new Cargo()],
                }
            ]);
        }
        setValue("containerDetails", [new Container()])
        setValue("mode", selectedType);
        clearErrors();

    }
    const showCargoDetailsOutGuage = watch("showCargoDetailsOutGuage")
    const checkcontainer = (containerDetails) => {
        let k = {}
        let l = true
        for (let j = 0; j < containerDetails.length; j++) {
            if (containerDetails[j]['containerType'] != undefined && containerDetails[j]['containerType'].length > 0) {
                let c = containerDetails[j]['containerType']
                if (k[c] == undefined) {
                    k[c] = Number(containerDetails[j]['wtPerContainer'])
                }
                if (k[c] != Number(containerDetails[j]['wtPerContainer'])) {
                    configStore.setModalMessage(
                        `Different Container Weight Not Allowed (${containerDetails[j]['containerType']})`
                    )
                    l = false
                }
            }
        }
        return l
    }
    const buttonRef = useRef();


    const [serverTime, setServerTime] = useState(0)
    const [routesEmptyMessage, setRoutesEmptyMessage] = useState('')
    const [routes, setRoutes] = useState([])
    const _params = (label, name, type = 'text', dataList = []) => {
        return {
            type, name, label, record: pricingStore,
            dataList
        }
    }
    useEffect(() => {
        enquiryStore.current.countryFromEnquiry = 'India'
    }, [])
    useEffect(() => {
        rtpStore.countryName = enquiryStore.current.countryFromEnquiry
    }, [enquiryStore.current.countryFromEnquiry])
    useEffect(() => {
        if (editStore.saveschedule) {
            setRoutes(JSON.parse(JSON.stringify(editStore.routes)))
        }
    }, [editStore.saveschedule])
    useEffect(() => {
        if (editStore.savecharge) {
            setRoutes(JSON.parse(JSON.stringify(editStore.routes)))
        }
    }, [editStore.savecharge])
    useEffect(() => {
        let r = [...routes]
        if (routeFilter == 'Cheapest')
            r.sort((a, b) => a.dummyContract.quoteValue < b.dummyContract.quoteValue ? -1 : 1)
        else
            r.sort((a, b) => a.minTransitTime < b.minTransitTime && a.minTransitTime > 0 ? -1 : 1)
        setRoutes(r)
    }, [routeFilter])
    useEffect(() => {
        rtpStore.records = routes;
        if (routes.length > 0) {
            setTimeout(() => {
                if (buttonRef.current) {
                    buttonRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }, 200)
        }
        console.log(" the routes are ", routes)
    }, [routes])
    useEffect(() => {
        rtpStore.pricingSourceScreen = 'pricing'
        return () => {
            configStore.homescreenCurrentView = "list"
        }
    }, [])
    const origin = watch("origin")
    const multidest = getValues("multidest") ? getValues("multidest") : watch("multidest")
    let Scope = watch("scope")
    useEffect(() => {
        if(!cwfVisible){
        setRoutes([])
        setRoutesEmptyMessage('')
        }
    }, [origin, JSON.stringify(multidest)])
    const getmrg = async (e) => {
        let m = JSON.parse(JSON.stringify(multidest))
        m[0]['cargoDetails'] = MRGCARGODETAILS
        setValue('multidest', m)

        let volumeInDimensions = getValues("volumeInDimensions") ? getValues("volumeInDimensions") : watch("volumeInDimensions")
        if (Scope?.includes("Door") && volumeInDimensions == true) {
            setValue('volumeInDimensions', false)
            setValue('multidest', m)
            let id
            id = setTimeout(() => {
                getmrg(e)
                clearTimeout(id)
            }, 2000);
        } else {
            const isValid = await trigger();
            if (isValid) {
                setMrg(true)
                handleSubmit(getRoutes)(e)
            }
        }



    }
    useEffect(() => {
        console.log("++++++++++++++++++96", routes)
        rtpStore.records = routes
        filtersState.setRoutes(routes, true, true);
    }, [routes])
    console.log('INSIDE HOMESCREEN spot V3')
    const rec = contractsStore.current
    const isMobile = useMobile();
    const [activeProduct, setActiveProduct] = useState(configStore.homescreenCurrentShipmentType)

    const displayVehicleTable = () => {
        return false
    }
    const getRoutes = async (data, e) => {
        if (enquiryStore.current.entityId == undefined || (enquiryStore.current.entityId != undefined && enquiryStore.current.entityId.trim().length == 0)) {
            configStore.setModalMessage('Select Customer')
            return
        }
        if ((enquiryStore.current.salesperson == undefined || (enquiryStore.current.salesperson != undefined && enquiryStore.current.salesperson.trim().length == 0)) && (enquiryStore.current.customerService == undefined || (enquiryStore.current.customerService != undefined && enquiryStore.current.customerService.trim().length == 0))) {
                    configStore.setModalMessage('Select Sales Person and Customer Service')
                    return
                }
        if (enquiryStore.current.salesperson == undefined || (enquiryStore.current.salesperson != undefined && enquiryStore.current.salesperson.trim().length == 0)) {
            configStore.setModalMessage('Select Sales Person')
            return
        }
        if (enquiryStore.current.customerService == undefined || (enquiryStore.current.customerService != undefined && enquiryStore.current.customerService.trim().length == 0)) {
            configStore.setModalMessage('Select Customer Service')
            return
        }
        if (cartingStore.current._id != undefined && cartingStore.current._id.length > 0) {
            setFreeze(true)
        }
        setmRates(false)
        setcwfVisible(false)
        contractsStore.current = {}
        if (checkcontainer(data.containerDetails)) {
            let cargo = []
            let container = []
            let obj = {}
            let multidest_new = []
            for (let i = 0; i < data.multidest.length; i++) {
                let z1 = {}
                z1['destination'] = data.multidest[i]['destination']
                z1['cargoDetails'] = []
                if (i == 0) {
                    enquiryStore.current.enqRoute.destination = data.multidest[i]['destination']
                } else {
                    let k = i + 1
                    enquiryStore.current.enqRoute['destination' + k] = data.multidest[i]['destination']
                }
                for (let j = 0; j < data.multidest[i]['cargoDetails'].length; j++) {
                    let k = data.multidest[i]['cargoDetails'][j]
                    k = Utils.setCargo_unit(k, data.multidest[0]['cargoDetails'][0], ['weight', 'chargeableWeight', 'volume', 'totalWeight', 'totalVolume', 'dimensions'], data.cargoDimensionUnit)
                    z1['cargoDetails'].push(k)
                    cargo.push(k)
                }
                multidest_new.push(z1)
            }
            for (let j = 0; j < data.containerDetails.length; j++) {
                let z = data.containerDetails[j]['containerType']
                if (obj[z] == undefined) {
                    obj[z] = {
                        containerType: "",
                        numContainers: 0,
                        unit: "",
                        wtPerContainer: 0
                    }
                }
                obj[z]['containerType'] = z
                obj[z]['unit'] = data.containerDetails[0]['unit']
                obj[z]['numContainers'] = obj[z]['numContainers'] + Number(data.containerDetails[j]['numContainers'])
                obj[z]['wtPerContainer'] = Number(data.containerDetails[j]['wtPerContainer'])
            }
            let o = Object.keys(obj)
            for (let i = 0; i < o.length; i++) {
                obj[o[i]]['wtPerContainer'] = obj[o[i]]['wtPerContainer']
                container.push(obj[o[i]])
            }
            enquiryStore.current.nonStackable = data.nonStackable ? 'Yes' : "No"
            enquiryStore.current.enqRoute.cargoReadinessDate = data.cargoreadinessdate
            enquiryStore.current.enqRoute.origin = data.origin
            enquiryStore.current.shipmentScope = data.scope
            if (data.mode == 'FCL') {
                enquiryStore.current.shipmentType = `FCL (${data.stuffingType}/${data.destuffingType})`;
            } else {
                enquiryStore.current.shipmentType = data.mode
            }
            enquiryStore.current.enqRoute.customerReferenceNum = data.customerreference
            enquiryStore.current.hazardous = data.hazardous ? 'Yes' : "No"
            enquiryStore.current.temperatureControlled = data.temperatureControlled ? 'Yes' : "No"
            enquiryStore.current.containerDetails = JSON.parse(JSON.stringify(container))
            enquiryStore.current.cargoDetails = JSON.parse(JSON.stringify(cargo))
            enquiryStore.current.cargoDimensionUnit = data.cargoDimensionUnit;
            enquiryStore.current.unnumber = data.unnumber;
            enquiryStore.current.packingGroup = data.packingGroup
            enquiryStore.current.quoteClass = data.quoteClass
            enquiryStore.current.stuffingType = data.stuffingType
            enquiryStore.current.destuffingType = data.destuffingType
            enquiryStore.current.minTemperature = data.minTemperature
            enquiryStore.current.maxTemperature = data.maxTemperature
            enquiryStore.current.temperature = data.temperature
            enquiryStore.current.cargoValue = data.cargoValue;
            enquiryStore.current.warehouse = data.warehouse;
            enquiryStore.current.volumeInDimensions = data.volumeInDimensions;
            enquiryStore.current.fba = data.isFba ? "Yes" : "No";
            enquiryStore.current.fbaIorRequired = data.ior ? "Yes" : "No";
            enquiryStore.current.fbaOCC = data.occ ? "Yes" : "No";
            enquiryStore.current.fbaDCC = data.dcc ? "Yes" : "No";
            enquiryStore.current.opal = data.opal
            enquiryStore.current.dpal = data.dpal
            enquiryStore.current.fbaPAL = data.palletizationandlabelling ? "Yes" : "No";
            enquiryStore.current.fbaSAD = data.storageAtDestination ? "Yes" : "No";
            enquiryStore.current.fbaSurvey = data.survey ? "Yes" : "No";
            enquiryStore.current.pick_up_by_amazon = data.pick_up_by_amazon ? "Yes" : "No";
            enquiryStore.current.fbaDays = data.days != undefined ? data.days : 0;
            enquiryStore.current.isfromAgragaEnquiry = 'Yes'
            if (cartingStore.current._id != undefined && cartingStore.current._id.length > 0) {
                enquiryStore.current.overHeight = data.overHeight ? "Yes" : "No";
                enquiryStore.current.overlength = data.overlength ? "Yes" : "No";
                enquiryStore.current.topLoading = data.topLoading ? "Yes" : "No";
                enquiryStore.current.fumigation = data.fumigation ? "Yes" : "No";
                enquiryStore.current.headLoad = data.headLoad ? "Yes" : "No";
                enquiryStore.current.doorLoad = data.doorLoad ? "Yes" : "No";
                enquiryStore.current.reefer = data.reefer ? "Yes" : "No";
                enquiryStore.current.overHeightValue = data.overHeightValue
                enquiryStore.current.overlengthValue = data.overlengthValue
            }
            if ((cartingStore.current._id == undefined || cartingStore.current._id.length == 0) && selectedType == 'FCL') {
                enquiryStore.current.searchDB = data.searchDB
                enquiryStore.current.searchFreightfy = data.searchFreightfy
                enquiryStore.current.searchCMACGM = data.searchCMACGM
            }
            let rec = enquiryStore.current
            // let l = Utils.enquiry_validation_check(rec, JSON.parse(JSON.stringify(multidest_new)))
            // if (l.length > 0) {
            //     if(process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE==="navexel" && enquiryStore.current.shipmentType.toUpperCase()==="LCL"){
            //         setRoutes([]);
            //         return;
            //     }
            //     configStore.setModalMessage(l[0])
            //     return
            // }
            enquiryStore.current.multidest = JSON.parse(JSON.stringify(multidest_new));
            bookingsStore.initialize()
            console.log('\n\n\n\n\n==============================')
            console.log('/', enquiryStore.current.enqRoute.origin, '/', enquiryStore.current.enqRoute.destination, rtpStore, '/\n===============\n\n\n')
            setRoutes([])
            setRoutesEmptyMessage('Fetching Routes ...')
            rtpStore.loadingMessage = 'Fetching Routes '
            rtpStore.loadingTimer = setInterval(() => {
                rtpStore.loadingCounter++
            }, 10000);
            setRouterFilter('Cheapest')
            let curDate = data.cargoreadinessdate
            let url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/pricing/getroutes`
            if (activeProduct == 'FCL') url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/fclpricing/getroutesv2`
            else if (activeProduct == 'Air') url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/airpricing/getroutes`
            let start = Date.now()
            if (loginStore.isClient()) pricingStore.entityId = configStore.currentSelectedEntity.entityId
            else configStore.currentSelectedEntity = { entityId: pricingStore.entityId }
            if (loginStore.isClient()) enquiryStore.current.entityId = configStore.currentSelectedEntity.entityId
            // enquiryStore.current.shipmentType = 'LCL'
            // enquiryStore.current.entity = pricingStore.gst
            enquiryStore.current.createdBy = loginStore.email
            let otype = enquiryStore.current.shipmentScope.split("-")[0];
            let dtype = enquiryStore.current.shipmentScope.split("-")[2];
            let crd = '' + enquiryStore.current.enqRoute.cargoReadinessDate
            crd = crd.trim()
            if (rtpStore.customerTBA == 'TBA') {
                enquiryStore.current.checkAgCustomer = 'No'
                enquiryStore.current.entityName = "YET TO BE ASSIGNED"
                enquiryStore.current.entityId = "TBA"
                enquiryStore.current.gst = 'GSTTBA000000000'
                enquiryStore.current.state = ''
                enquiryStore.current.createdBy = loginStore.email
                enquiryStore.current.isfromAgragaEnquiry = 'Yes'
            }
            let dimunit = enquiryStore.current.cargoDimensionUnit
            for (let e of enquiryStore.current.cargoDetails) {
                e.dimensions.unit = dimunit
            }
            let displayCargo4fcl = false
            let stype = enquiryStore.current.shipmentType.substr(0, 3).toLowerCase()
            displayCargo4fcl = false
            if (stype === 'fcl') {
                displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
                if (enquiryStore.current.originType != 'Port' && enquiryStore.current.stuffingType != 'Factory') displayCargo4fcl = true
                if (enquiryStore.current.destinationType != 'Port' && enquiryStore.current.destuffingType != 'Factory') displayCargo4fcl = true
            }
            let payload = {
                entity: enquiryStore.current.entityId,
                // entity: "CEN0665",
                origin: enquiryStore.current.enqRoute.origin,
                destination: enquiryStore.current.enqRoute.destination,
                sscope: `${otype}-to-${dtype}`,
                crd: enquiryStore.current.enqRoute.cargoReadinessDate,
                curDate,
                cargoDetails: enquiryStore.current.cargoDetails,
                vehicleDetails: enquiryStore.current.vehicleDetails,
                fclCargoApplicable: displayCargo4fcl,
                enquiry: enquiryStore.current
            }
            for (let i = 1; i < multidest_new.length; i++) {
                if (i != 0) {
                    let k = i + 1
                    payload['destination' + k] = multidest_new[i]['destination']
                }
            }
            if (rtpStore.customerTBA == 'TBA') {
                payload.entity = 'COUNTRY:' + rtpStore.countryName
            }
            if (!PricingUtils.getTotalVehicleCount(payload.vehicleDetails) && displayVehicleTable()) {
                configStore.setModalMessage('At least one vehicle needs to be selected for India transport=')
                return
            }
            let ocountry = 'origin'
            let portre = /.*\((.....)\)$/
            let doorre = /.*\[(..,.*)\]$/
            let origin1 = payload.origin
            let destination1 = payload.destination
            if (origin1.includes('(') || origin1.includes('[')) {
                if (otype == 'Port') ocountry = origin1.match(portre)[1].slice(0, 2)
                else ocountry = origin1.match(doorre)[1].slice(0, 2)
            }
            let dcountry = 'destination'
            if (destination1.includes('(') || destination1.includes('[')) {
                if (dtype == 'Port') dcountry = destination1.match(portre)[1].slice(0, 2)
                else dcountry = destination1.match(doorre)[1].slice(0, 2)
            }
            //console.log('$$$$', payload.origin, payload.destination, ocountry, dcountry)
            if (ocountry == dcountry) {
                configStore.setModalMessage('We do not have Domestic Transport Capabilities at present' + ocountry + '/' + dcountry)
                return
            }
            setPayloaddata(payload)
            let ret = []
            if (ocountry != 'IN' && ocountry != 'origin' && dcountry != 'IN' && dcountry != 'destination') {
                /*configStore.setModalMessage('We do not serve these routes at present and will keep you posted when we launch in these markets')
                enquiryStore.current.enqRoute.origin = ''
                enquiryStore.current.enqRoute.destination = ''
                return*/
            } else if (enquiryStore.current.shipmentType != "Air") ret = await MonApi.apost(url, payload)
            if (ret.additionalsets) rtpStore.additionalsets = ret.additionalsets
            if (ret.finalset) ret = ret.finalset
            rtpStore.dpd = 'Direct Port Delivery'
            // ##################################################################
            console.log('payload==', JSON.stringify(payload))
            //console.log('new data=', enquiryStore.current.originType, enquiryStore.current.destinationType)
            setServerTime(Date.now() - start)
            clearInterval(rtpStore.loadingTimer)
            rtpStore.loadingCounter = 0
            console.log("The ret is ", ret);
            if (ret.error) {
                if (cartingStore.current._id != undefined && cartingStore.current._id.length > 0 && enquiryStore.current.shipmentScope.indexOf('Door') != -1) {
                    setRoutesEmptyMessage('No Routes')
                } else {
                    setRoutesEmptyMessage('')
                    configStore.setModalMessage('' + ret.error, [], true, [], '', 5000)
                }
            } else {
                for (let i = 0; i < ret.length; i++) {
                    ret[i].dummyContract['entityId'] = enquiryStore.current.entityId
                    ret[i].dummyContract['nomination'] = enquiryStore.current.nomination
                    ret[i].dummyContract['salesperson'] = enquiryStore.current.salesperson
                    ret[i].dummyContract['customerService'] = enquiryStore.current.customerService
                    ret[i].dummyContract['entityName'] = enquiryStore.current.entityName
                    ret[i].quote['entityId'] = enquiryStore.current.entityId
                    ret[i].quote['nomination'] = enquiryStore.current.nomination
                    ret[i].quote['salesperson'] = enquiryStore.current.salesperson
                    ret[i].quote['customerService'] = enquiryStore.current.customerService
                    ret[i].quote['entityName'] = enquiryStore.current.entityName
                    ret[i].quote.quoteSummary['entityId'] = enquiryStore.current.entityId
                    ret[i].quote.quoteData['entityId'] = enquiryStore.current.entityId
                    ret[i].quote.quoteData['nomination'] = enquiryStore.current.nomination
                    ret[i].quote.quoteData['salesperson'] = enquiryStore.current.salesperson
                    ret[i].quote.quoteData['customerService'] = enquiryStore.current.customerService
                    ret[i].quote.quoteData['entityName'] = enquiryStore.current.entityName
                    if (i == ret.length - 1) {
                        setRoutes(ret)
                    }
                }
                if (!ret || !ret.length) setRoutesEmptyMessage('No Routes')
            }
        }
    }
    useSnapshot(loader)
    useEffect(() => {
        if (!loginStore.isClient() && (!EntityV2Store.Cuslist || EntityV2Store.Cuslist.length === 0)) {
            EntityApi.getList();
        }
    }, []);

    if (EntityV2Store.Cuslist.length == 0 && !loginStore.isClient()) {
        loader.show()
    } else {
        loader.hide()
    }

    useEffect(() => {
        const agactiveuserlist = () => {
            let l = []
            for (let i = 0; i < aguserStore.list.length; i++) {
                let e = aguserStore.list[i]
                if (e['status'] == "ACTIVE" && e['email'].indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) != -1) {
                    l.push(
                        {
                            label: aguserStore.getName4email(e['email']),
                            value: aguserStore.getName4email(e['email'])
                        }
                    )
                }
            }
            if (JSON.stringify(agActiveList) != JSON.stringify(l)) {
                setAgActiveList(l)
            }
        }
        agactiveuserlist()
    }, [aguserStore.list])

    useEffect(() => {
        if (cartingStore.current._id != undefined && cartingStore.current._id.length > 0 && !freeze) {
            AguserApi.getList();
            setActiveProduct(cartingStore.current.mode)
            setType(cartingStore.current.mode)
            setValue("cartingorder", true)
            setValue("cartingorderdisable", true)
        } else {
            AguserApi.getList();
        }
    }, [JSON.stringify(cartingStore.current)])

    useEffect(() => {
        let l = false
        if (cwfVisible || freeze) {
            l = true
        } else {
            l = false
        }
        if (showonly != l) {
            setShowonly(l)
        }
    }, [cwfVisible, freeze])

    useEffect(() => {
        if (cartingStore.current._id != undefined && cartingStore.current._id.length > 0) {
            cartingStore.current.salesperson = enquiryStore.current.salesperson
            cartingStore.current.customerService = enquiryStore.current.customerService
        }

    }, [enquiryStore.current.salesperson, enquiryStore.current.customerService])

    useEffect(() => {
        // if(cartingStore.current._id!=undefined && cartingStore.current._id.length>0){
        //     getEntityData()
        // }
        getEntityData()

        console.log("enquiryStore.current", enquiryStore.current, enquiryStore.current.entityId);
    }, [enquiryStore.current.entityId, cartingStore.current.nomination, enquiryStore.current.nomination, enquiryStore.current.shipmentType, cartingStore.current.shipmentType])
    const getEntityData = async () => {
        // console.log("enquiryStore.current",enquiryStore.current,enquiryStore.current.entityId);
        //   enquiryStore.current.salesperson = "";
        //   enquiryStore.current.customerService = ""
        if (enquiryStore.current.entityId == undefined || (enquiryStore.current.entityId != undefined && enquiryStore.current.entityId.length == 0)) {
            enquiryStore.current.salesperson = "";
            enquiryStore.current.customerService = ""
            return ""
        }
        let entity = await EntityV2Api.viewEntity(enquiryStore.current.entityId)
        console.warn("FOUND ENTITY = ", entity);
        if (entity) {
            enquiryStore.current.entityName = entity.entityName
            if (enquiryStore.current.salesperson == undefined || (enquiryStore.current.salesperson != undefined && enquiryStore.current.salesperson.length == 0)) {
                let k = []
                let tradeType = Utils.getTradeType({
                    rec: enquiryStore.current,
                    shipmentType: enquiryStore.current.shipmentType,
                    entityCountry: entity.entityCountry
                })
                if (!enquiryStore.current.portOfReceipt) {
                    tradeType = "Export"
                }

                // let rmEmailList = entity?.customer?.crossBorder?.relationshipManagers;
                let rmList = entity.customer.crossBorder.relationshipManagers
                let nomination
                if (TenantUtils.isNavexel() && cartingStore.current._id != undefined && cartingStore.current._id.length > 0) {
                    nomination = cartingStore.current.nomination
                } else {
                    nomination = enquiryStore.current.nomination
                }
                let rmemails = Utils.getRelationShipMangerForType(rmList, enquiryStore.current.shipmentType, tradeType, nomination);
                //   let rmemails = Utils.getRelationShipMangerForType(rmEmailList , "LCL" , "import" );
                if (rmemails.length > 0 && rmemails[0]?.email?.length > 0) {
                    rmemails.map((x, y) => {
                        k.push(aguserStore.getdetails(x.email))
                    })
                    let e = aguserStore.getName4email(rmemails[0]?.email)
                    enquiryStore.current.salesperson = aguserStore.getName4email(rmemails[0].email);
                    cartingStore.current.salesperson = aguserStore.getName4email(rmemails[0].email);
                    setValue('salesperson', e)
                }
                else {
                    enquiryStore.current.salesperson = "";
                    cartingStore.current.salesperson = ""
                    setValue('salesperson', "")
                }
            }
            if (enquiryStore.current.customerService == undefined || (enquiryStore.current.customerService != undefined && enquiryStore.current.customerService.length == 0)) {
                let tradeType = Utils.getTradeType({
                    rec: enquiryStore.current,
                    shipmentType: enquiryStore.current.shipmentType,
                    entityCountry: entity.entityCountry
                })
                if (!enquiryStore.current.portOfReceipt) {
                    tradeType = "Export"
                }
                let csList = entity.customer.crossBorder.customerService
                let nomination
                if (TenantUtils.isNavexel() && cartingStore.current._id != undefined && cartingStore.current._id.length > 0) {
                    nomination = cartingStore.current.nomination
                } else {
                    nomination = enquiryStore.current.nomination
                }
                let csemails = Utils.getCustomerServiceForType(csList, enquiryStore.current.shipmentType, tradeType, nomination);
                let k = []
                if (csemails.length > 0 && csemails[0]?.email?.length > 0) {
                    csemails.map((x, y) => {
                        k.push(aguserStore.getdetails(x.email))
                    })
                    let e = aguserStore.getName4email(csemails[0]?.email)
                    enquiryStore.current.customerService = e;
                    cartingStore.current.customerService = e;
                    setValue('customerService', e)
                } else {
                    enquiryStore.current.customerService = "";
                    cartingStore.current.customerService = ""
                    setValue('customerService', "")
                }
            }

        }
    }


    const hasRoutes = ()=> {        
        if(routes?.length > 0){
         return true
        }else {
         return false   
        }
    }

    useEffect(()=>{
        if(TenantUtils.isNavexel()){
        let payload = {}
        if(enquiryStore.current.entityId!==undefined && enquiryStore.current.entityId.length>0){
            payload['entityId'] = enquiryStore.current.entityId
                if(origin != null && origin!==undefined && origin.length>0){
                payload['origin'] = origin
            }
            if(multidest!==undefined && multidest.length>0 && multidest[0]['destination']!==null && multidest[0]['destination']!==undefined && multidest[0]['destination'].length>0){
                payload['destination'] = multidest[0]['destination']
            }
            if(!isEqual(rateRequestpayload,payload)){
                setRateRequestpayload(payload)
                const callBack = (data)=>{
                    enquiryStore.rateRequestlist = JSON.parse(JSON.stringify(data))
                }
                Api.getRaterequest(payload,callBack)
            }
        }}
    },[enquiryStore.current.entityId,origin,JSON.stringify(multidest),enquiryStore.checkRateRequest])
  

    console.log('*** ### INSIDE SPOT.BOOKING.V3.JS', rec, props.viewonly, bookingsStore.current)
    let title = 'Quick Quote'
    if (cartingStore.current._id != undefined && cartingStore.current._id.length > 0) {
        title = 'Create Booking with Carting'
    }

    return (
        <>
            {
                (EntityV2Store.Cuslist.length > 0 || loginStore.isClient()) && <>
                    <p><hr /></p>
                    <EnquiryConfirmationv3 setType={setType} />
                    {
                        configStore.quotationModalVisible4 && <ActrejectModalV3 fromPricing={true} />
                    }
                    <h5 className="title is-4" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontFamily: 'product_sans_bold' }}>
                        {title}
                    </h5>

                    <div className="columns">
                        <div className="column is-4" >
                            <label><strong>Customer</strong></label>
                            <AgCustlist {..._params('', '', 'entityId', EntityV2Store.Cuslist)} name='entityId' record={enquiryStore.current} isDisabled={{disabled:showonly || hasRoutes()}}/>
                        </div>
                        {/* {console.log('crvfvf' ,  cartingStore.current , cartingStore)} */}
                        {(TenantUtils.isNavexel() && cartingStore.current._id != undefined && cartingStore.current._id.length > 0) ? <>
                            <div className="column is-2" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                {/* <span onClick={()=>setIsNomination(!isNomination)}> */}
                                  <p style={{ margin: 0, fontWeight: '600', fontSize: '0.9rem', color: '#1E293B' }}>Nomination</p>
                                <span onClick={hasRoutes() ? null : () => {
                                    if (!showonly) {
                                        cartingStore.current.nomination = !cartingStore.current.nomination;
                                        enquiryStore.current.salesperson = "";
                                        enquiryStore.current.customerService = ""
                                    }
                                }}  disabled = { hasRoutes()} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', cursor: hasRoutes() ? 'default' : 'pointer' }}>                                  
                                    {
                                        (cartingStore.current.nomination) ?
                                            <img height='36px' width='36px' src={on} alt="on" style={{ margin: 0 }}></img> :
                                            <img height='36px' width='36px' src={off} alt="off" style={{ margin: 0 }}></img>
                                    }
                                </span>
                            </div>
                        </> :
                          <div className="column is-2" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' , alignItems: 'center' }}>
                            {/* <span onClick={()=>setIsNomination(!isNomination)}> */}
                                                            <p style={{ margin: 0, fontWeight: '600', fontSize: '0.9rem', color: '#1E293B' }}>Nomination</p>
                            <span onClick={hasRoutes() ? null :() =>{ 
                                if (!showonly) {
                                enquiryStore.current.nomination = !enquiryStore.current.nomination ;
                            enquiryStore.current.salesperson = "" ;
                            enquiryStore.current.customerService= ""
                                }
                            }} disabled = { hasRoutes()} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '40px', cursor: hasRoutes() ? 'default' : 'pointer' }}>
                                {
                                    (enquiryStore.current.nomination) ?
                                        <img height='36px' width='36px' src={on} alt="on" style={{ margin: 0 }}></img> :
                                        <img height='36px' width='36px' src={off} alt="off" style={{ margin: 0 }}></img>
                                }
                            </span>
                        </div>  
                        }

                        {/* {cartingStore.current._id!=undefined && cartingStore.current._id.length>0 && */}
                        {
                         <><div className="column is-3" >
                            <label><strong>Sales Person</strong></label>
                            <AgSelectNew
                                          {..._params(
                                            "",
                                            "salesperson",
                                            "select",
                                            agActiveList
                                          )}
                                          name='salesperson' record={enquiryStore.current}
                                          isDisabled={{disabled:showonly || hasRoutes()}}
                                        />
                        </div>
                        <div className="column is-3" >
                            <label><strong>Customer Service</strong></label>
                            <AgSelectNew
                                          {..._params(
                                            "",
                                            "customerService",
                                            "select",
                                            agActiveList
                                          )}
                                          name='customerService' record={enquiryStore.current}
                                          isDisabled={{disabled:showonly || hasRoutes()}}
                                        />
                        </div></>}
                    </div>

                    {
                        (!props.viewonly && !showonly) ?
                            <div style={{ width: "100%" }}>
                                <ActiveTab callback={changeShipmentTypes} viewonly={viewonly == '1'} selectedType={selectedType} source="spot" />
                            </div>
                            : <></>
                    }
                    <form noValidate onSubmit={handleSubmit(getRoutes)} style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                        <div className={`flex ${isMobile ? "flex-col" : "flex-row"} gap-[10px]`}>
                            <Route form={cargoForm} viewonly={showonly} carting={cartingStore.current._id != undefined && cartingStore.current._id.length > 0} cwfVisible={cwfVisible}/>
                            <Details form={cargoForm} viewonly={showonly} fclfilter={((cartingStore.current._id == undefined || cartingStore.current._id.length == 0) && selectedType == 'FCL') ? true : false} carting={cartingStore.current._id != undefined && cartingStore.current._id.length > 0} cwfVisible={cwfVisible}/>
                        </div>




                        <div className="columns">
                            <div className="column is-12">
                                {
                                    (props.viewonly && loginStore.isClient()) ?
                                        <button style={{ float: 'left' }}
                                            className="button is-rounded is-small islink" onClick={() => {
                                                let customTC = []
                                                if (rec['customTC']) {
                                                    customTC = rec['customTC'].split(/\r?\n/)
                                                }
                                                rec['tc'].map(e => customTC.push(e))
                                                configStore.setModalMessage("", [], false, customTC)
                                            }}>Terms and Conditions</button> :
                                        <></>


                                }


                                <BookingConfirmation />
                                {
                                    (!cwfVisible) ?
                                        <div className="columns"><div className="column is-2"><div className="columns" style={{ display: 'flex', justifyContent: "flex-start", paddingTop: '5px' }}>
                                            <div className="column is-2">
                                                {(TenantUtils.isNavexel() && (cartingStore.current._id == undefined || cartingStore.current._id.length == 0) && selectedType == 'LCL' && multidest != undefined && multidest.length == 1 && enquiryStore.current.entityId != undefined && enquiryStore.current.entityId.trim().length != 0 && origin != undefined && origin.length != 0 && multidest[0]['destination'] != undefined && multidest[0]['destination']) && <button onClick={async (e) => {
                                                    getmrg(e)
                                                }} className="button islink " type="button" style={{ marginLeft: '3px' }}>Get MRG</button>}
                                            </div></div></div>
                                            <div className="column is-10"><div className="columns" style={{ display: 'flex', justifyContent: "flex-end", paddingTop: '5px' }}>
                                                <div className="column is-9">
                                                    {
                                                        !routes?.length ?
                                                            <RoutesEmpty message={routesEmptyMessage} setMessage={setRoutesEmptyMessage} setRoutes={setRoutes} setmRates={setmRates} payloaddata={payloaddata} />
                                                            : <></>
                                                    }
                                                </div>
                                                {
                                                    (cartingStore.current._id == undefined || cartingStore.current._id.length == 0) ? <>
                                                        {(filtersState.filteredList && filtersState.filteredList?.length > 0) || (filtersState.optionalFilteredList && filtersState.optionalFilteredList?.length > 0) ?
                                                            <>{(!mrg) && <div className="column is-2">
                                                                <button className="button" style={{ marginRight: '3px' }}
                                                                    onClick={(e) => {
                                                                        configStore.quotationModalVisible4 = true
                                                                    }}
                                                                >Raise Enquiry</button>
                                                            </div>}</> : <></>

                                                        }

                                                        <div className="column is-1">
                                                            <button className="button" style={{ marginLeft: '3px' }}
                                                                onClick={(e) => {
                                                                    setMrg(false)
                                                                    enquiryStore.initialize()
                                                                    enquiryStore.current.originType = 'Port'
                                                                    enquiryStore.current.destinationType = 'Port'
                                                                }}
                                                            >Clear</button>
                                                        </div>
                                                    </> : ""
                                                }
                                                {!mrg && <div className="column is-2">
                                                    <button onClick={async (e) => {
                                                        setMrg(false)
                                                        const isValid = await trigger();
                                                        if (isValid) {
                                                            handleSubmit(getRoutes)(e)
                                                        }
                                                    }} className="button islink " type="button" style={{ marginLeft: '3px' }}>Get Rates</button>
                                                </div>}
                                            </div></div></div>
                                        : <></>
                                }
                            </div>
                        </div >
                    </form>
                    <hr />
                    {
                        (!cwfVisible && (cartingStore.current._id == undefined || cartingStore.current._id.length == 0) && enquiryStore.rateRequestlist.length>0) && 
                        <div className="columns">
                            {
                                enquiryStore.rateRequestlist.map((e)=>{
                                    return <>{ Object.keys(e).length>0 && <div className="column is-4">
                            <div className="card m-2">
                                <div className="card-content">
                                    <div style={{display:"flex"}}>

                                    
                                    <div class="notification is-link m-1 p-1">
  {e.quoteData.shipmentScope}
</div>
<div class="notification is-danger m-1 p-1">
  {e._id}
</div>
</div>
                                    <div style={{ display: "flex" , alignItems: "center" , }}>
                                        <div class="location">
                                            <svg viewBox="0 0 24 24" width="30" height="30">
                                            <path
                                                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"
                                                fill="none" stroke="#4b4bb3" stroke-width="1.5" />
                                            </svg>
                                        </div>
                                        {e.quoteData.origin}
                                    </div>
                                    <div style={{height: "2vh",
  borderLeft: "3px dashed #4b4bb3",
  marginLeft: "4%"}}></div>
  <div style={{ display: "flex" , alignItems: "center" , marginTop:"2%" }}>
                                        <div class="location">
                                            <svg viewBox="0 0 24 24" width="30" height="30">
                                            <path
                                                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"
                                                fill="none" stroke="#4b4bb3" stroke-width="1.5" />
                                            </svg>
                                        </div>
                                        {e.quoteData.destination}
                                    </div>
                                </div>
                            </div>
                        </div>}</>
                                })
                            }
                        
                    </div>
                    }
                    {
                        (routes.length > 0) ? <>
                            {
                                (cwfVisible) ?
                                    <Pricingcwf hideme={setcwfVisible} activeProduct={activeProduct} carting={cartingStore.current._id != undefined && cartingStore.current._id.length > 0} trigger={trigger} watch={watch} getValues={getValues}/>
                                    :
                                    <>{(mrates == false) ?
                                        <div ref={buttonRef} className="columns">
                                            <div className="column is-12">
                                                {(filtersState.routes?.length > 0) && <>
                                                    <div className="flex flex-row justify-end my-1 items-center">
                                                        {
                                                            (cartingStore.current._id != undefined && cartingStore.current._id.length > 0) ? <button className="button islink " style={{ marginRight: '1%' }} onClick={() => {
                                                                cartingStore.current.internalremarks = ""
                                                                cartingStore.current.supportingDocuments_list = []
                                                                const callback = (data) => {
                                                                    let dummyContract = {
                                                                        origin: enquiryStore.current.enqRoute.origin,
                                                                        portOfReceipt: cartingStore.current.portOfReceipt,
                                                                        portOfLoading: cartingStore.current.portOfLoading,
                                                                        portOfDischarge: cartingStore.current.portOfDischarge,
                                                                        finalPlaceOfDelivery: cartingStore.current.finalPlaceOfDelivery,
                                                                        destination: enquiryStore.current.enqRoute.destination,
                                                                        shipmentType: selectedType,
                                                                        shipmentScope: enquiryStore.current.shipmentScope,
                                                                        isCarting: "Yes",
                                                                        reworkingPort: cartingStore.current.reworkingPort

                                                                    }
                                                                    Object.assign(data, dummyContract)
                                                                    if (enquiryStore.current.shipmentType == 'Air') {
                                                                        data.tc = getTC(enquiryStore.current.shipmentType)
                                                                    }
                                                                    setRoutes([{ sources: [], dummyContract: data }])
                                                                    data.schedules = []
                                                                    data.chargesList = []
                                                                    data.shipmentType = selectedType
                                                                    contractsStore.current = JSON.parse(JSON.stringify(data))
                                                                    cartingStore.setSchedule()
                                                                    setmRates(true)
                                                                }
                                                                Api.getdummycontranct(payloaddata, callback)
                                                            }}>Enter Rates Manually</button> : <></>
                                                        }
                                                        {filtersState.routes?.length > 0 && <FiltersMenu showSortBy={activeProduct !== "AIR"} />}
                                                    </div></>}
                                                {openScheduleModel &&
                                                    <div className='modal is-active' >
                                                        <div className="modal-background" ></div>
                                                        <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px', width: "90%" }} >
                                                            <section className="modal-card-body">
                                                                <EditSchedule setOpenScheduleModel={setOpenScheduleModel} setRoutes={setRoutes} routes={routes} />
                                                            </section>
                                                        </div>
                                                    </div>
                                                }
                                                {openChargeModel &&
                                                    <div className='modal is-active' >
                                                        <div className="modal-background" ></div>
                                                        <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px', width: "100%" }} >
                                                            <section className="modal-card-body">
                                                                {
                                                                    editStore.mrg ? <EditChargenew setOpenChargeModel={setOpenChargeModel} setRoutes={setRoutes} routes={routes} /> :
                                                                        <EditCharge setOpenChargeModel={setOpenChargeModel} setRoutes={setRoutes} routes={routes} />
                                                                }
                                                            </section>
                                                        </div>
                                                    </div>
                                                }
                                                {openCopyMail &&
                                                    <div className='modal is-active' >
                                                        <div className="modal-background" ></div>
                                                        <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px', width: "90%" }} >
                                                            <section className="modal-card-body">
                                                                <CopyMail setOpenCopyMail={setOpenCopyMail} />
                                                            </section>
                                                        </div>
                                                    </div>
                                                }
                                                {

                                                    filtersState.routes?.length === 0 ?
                                                        //   <Nodata height="200px" message="No routes found for the selected filters." />
                                                        <></>
                                                        :
                                                        <>
                                                            {/* {
                                                activeProduct == 'LCL' &&
                                                <div className="columns">
                                                    <div className="column is-4">
                                                        {loginStore.isClient() ? <Button ref={buttonRef} onClick={() => {
                                                            setRouterFilter('Cheapest')
                                                        }} variant={routeFilter === "Cheapest" ? "contained" : ""} startIcon={<i class="fa-solid fa-money-check-dollar"></i>} sx={{
                                                            textTransform: "capitalize", marginRight: "10px", backgroundColor: routeFilter === "Cheapest" ? "#2A6ED4" : "white", "&:hover": {
                                                                backgroundColor: routeFilter === "Cheapest" ? "#2A6ED4" : "white"
                                                            }
                                                        }}>Cheapest</Button> : <button className={'button ' + cheapestColor} onClick={(e) => {
                                                            setRouterFilter('Cheapest')
                                                        }}>
                                                            <span className="icon" style={{ marginRight: '5px' }}>
                                                                <i class="fa-solid fa-money-check-dollar"></i>
                                                            </span>
                                                            Cheapest
                                                        </button>}
                                                        {loginStore.isClient() ? <Button onClick={() => {
                                                            setRouterFilter('Fastest')
                                                        }} startIcon={<i class="fa-solid fa-clock"></i>} variant={routeFilter === "Cheapest" ? "" : "contained"} sx={{
                                                            textTransform: "capitalize"
                                                            , backgroundColor: routeFilter === "Cheapest" ? "white" : "", "&:hover": {
                                                                backgroundColor: routeFilter === "Cheapest" ? "white" : "#2A6ED4"
                                                            }
                                                        }}>Fastest</Button> : <button className={'button ' + fastestColor}
                                                            style={{ marginLeft: '1rem' }} onClick={(e) => {
                                                                setRouterFilter('Fastest')
                                                            }}>
                                                            <span className="icon" style={{ marginRight: '5px' }}>
                                                                <i class="fa-solid fa-clock"></i>
                                                            </span>
                                                            Fastest
                                                        </button>}
                                                    </div>
                                                    <div className="column is-4"></div>
                                                </div>
                                            } */}

                                                            {
                                                                activeProduct == 'LCL' &&
                                                                <>
                                                                    <SpotLCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.filteredList}
                                                                        cwfVisible={cwfVisible} setcwfVisible={setcwfVisible} setOpenScheduleModel={setOpenScheduleModel} setOpenChargeModel={setOpenChargeModel} setOpenCopyMail={setOpenCopyMail} mrg={mrg} />
                                                                    {filtersState.optionalFilteredList.length > 0 && <div className="flex flex-col gap-2 mt-2 items-center">
                                                                        {filtersState.filteredList?.length === 0 ? <>
                                                                            <p className="font-bold">No results found for your filter.</p>
                                                                            <p>But don’t worry — we’ve picked some suggested routes you might be interested in!</p>
                                                                        </> : <p>we’ve picked some suggested routes you might be interested in!</p>}
                                                                        <SpotLCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.optionalFilteredList}
                                                                            cwfVisible={cwfVisible} setcwfVisible={setcwfVisible} setOpenScheduleModel={setOpenScheduleModel} setOpenChargeModel={setOpenChargeModel} setOpenCopyMail={setOpenCopyMail} mrg={mrg} />
                                                                    </div>}
                                                                </>
                                                            }
                                                            {
                                                                activeProduct == 'FCL' &&
                                                                <>
                                                                    <SpotFCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.filteredList}
                                                                        cwfVisible={cwfVisible} setcwfVisible={setcwfVisible} setOpenScheduleModel={setOpenScheduleModel} setOpenChargeModel={setOpenChargeModel} setOpenCopyMail={setOpenCopyMail} />
                                                                    {filtersState.optionalFilteredList.length > 0 && <div className="flex flex-col gap-2 mt-2 items-center">
                                                                        {filtersState.filteredList?.length === 0 ? <>
                                                                            <p className="font-bold">No results found for your filter.</p>
                                                                            <p>But don’t worry — we’ve picked some suggested routes you might be interested in!</p>
                                                                        </> : <p>we’ve picked some suggested routes you might be interested in!</p>}
                                                                        <SpotFCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.optionalFilteredList}
                                                                            cwfVisible={cwfVisible} setcwfVisible={setcwfVisible} setOpenScheduleModel={setOpenScheduleModel} setOpenChargeModel={setOpenChargeModel} setOpenCopyMail={setOpenCopyMail} />
                                                                    </div>}
                                                                </>
                                                            }
                                                            {
                                                                activeProduct == 'Air' &&
                                                                <>
                                                                    <SpotAirDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.filteredList}
                                                                        cwfVisible={cwfVisible} setcwfVisible={setcwfVisible} />
                                                                    {filtersState.optionalFilteredList.length > 0 && <div className="flex flex-col gap-2 mt-2 items-center">
                                                                        {filtersState.filteredList?.length === 0 ? <>
                                                                            <p className="font-bold">No results found for your filter.</p>
                                                                            <p>But don’t worry — we’ve picked some suggested routes you might be interested in!</p>
                                                                        </> : <p>we’ve picked some suggested routes you might be interested in!</p>}
                                                                        <SpotAirDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.optionalFilteredList}
                                                                            cwfVisible={cwfVisible} setcwfVisible={setcwfVisible} />
                                                                    </div>}
                                                                </>
                                                            }
                                                        </>
                                                }
                                            </div>
                                        </div> :
                                        <ManualRates routes={routes} cwfVisible={cwfVisible} setRoutes={setRoutes} hideme={setcwfVisible} close={setmRates} />
                                    }</>
                            }
                        </> : ""

                    }
                </>
            }
        </>

    )

}